(() => {
  'use strict';
  if (window.MRArticlePhotoViewer) { window.MRArticlePhotoViewer.init(document); return; }
  const controllers = new WeakMap();
  const candidates = 'a[data-interview-photo] img, .mr-article img, .mr-enhanced-body img, .mr-intro-copy img, .mr-hero > img, .mr-hero > picture img';
  const excluded = 'dialog, .mr-sidebar, .mr-related, .mr-authors, .mr-tutorial, .mr-comparison, .mre-before-after, .mre-qr, .mre-team, .mre-testimonial, button, [data-mr-no-enlarge]';
  function photoSource(photo) {
    const link = photo.closest('a');
    let source = photo.dataset.mrBackupUsed ? photo.src : link?.href || photo.getAttribute('data-src') || photo.getAttribute('src') || photo.currentSrc;
    try {
      const url = new URL(source, document.baseURI);
      if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) {
        if (!url.pathname.includes('/assets/')) {
          url.searchParams.set('width', '3000');
          url.searchParams.delete('height');
          url.searchParams.delete('crop');
        }
      }
      if (!['http:', 'https:', 'data:', 'blob:'].includes(url.protocol)) return '';
      return url.href;
    } catch (_) { return ''; }
  }
  function eligible(photo) {
    if (photo.closest(excluded) || photo.getAttribute('aria-hidden') === 'true') return false;
    const link = photo.closest('a');
    if (link && !link.matches('[data-interview-photo], [data-mre-lightbox], .mrag-image-link') && !/\.(?:jpe?g|png|webp|avif|gif)(?:[?#]|$)/i.test(link.href)) return false;
    if (!photo.closest('.mr-photo, .mrag-slide, .sp-gallery-slide, [data-mre-lightbox]') && photo.width > 0 && photo.width <= 100 && photo.height > 0 && photo.height <= 100) return false;
    return !!photoSource(photo);
  }
  function init(scope) {
    const roots = [...scope.querySelectorAll('#mr-journal')];
    if (scope.matches?.('#mr-journal')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const dialog = root.querySelector('.sp-photo-viewer');
      if (!dialog?.showModal) return;
      const events = new AbortController(), options = {signal: events.signal};
      const image = dialog.querySelector('img'), caption = dialog.querySelector('figcaption');
      const count = dialog.querySelector('.sp-viewer-count'), close = dialog.querySelector('[data-viewer-close]');
      const previous = dialog.querySelector('[data-viewer-prev]'), next = dialog.querySelector('[data-viewer-next]');
      const figure = dialog.querySelector('figure');
      let photos = [], index = 0, restoreFocus = null, previousOverflow = '', touch = null, refreshFrame = 0;
      function collect() { return [...root.querySelectorAll(candidates)].filter(eligible); }
      function refresh() {
        refreshFrame = 0;
        collect().forEach(photo => {
          photo.dataset.mrEnlarge = 'true';
          if (!photo.closest('a')) {
            photo.tabIndex = 0;
            photo.setAttribute('role', 'button');
            photo.setAttribute('aria-label', dialog.dataset.enlargeLabel + (photo.alt ? ': ' + photo.alt : ''));
          }
        });
      }
      function show(nextIndex) {
        index = Math.max(0, Math.min(photos.length - 1, nextIndex));
        const photo = photos[index];
        image.dataset.mrImageBackup = photo.getAttribute('data-mr-image-backup') || '';
        delete image.dataset.mrBackupUsed;
        image.alt = photo.alt || '';
        image.src = photoSource(photo);
        caption.textContent = photo.closest('.sp-gallery-slide')?.dataset.caption || photo.closest('figure')?.querySelector('figcaption')?.textContent.trim() || '';
        count.textContent = (index + 1) + ' / ' + photos.length;
        previous.disabled = index === 0;
        next.disabled = index === photos.length - 1;
      }
      function open(photo) {
        photos = collect().filter(item => item.getClientRects().length > 0);
        const selected = photos.indexOf(photo);
        if (selected < 0) return;
        restoreFocus = photo.closest('a') || photo;
        previousOverflow = document.body.style.overflow;
        show(selected);
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus({preventScroll: true});
      }
      function useImageBackup(failed) {
        if (!(failed instanceof HTMLImageElement)) return;
        const backup = failed.getAttribute('data-mr-image-backup')?.trim();
        if (!backup || failed.dataset.mrBackupUsed) return;
        failed.dataset.mrBackupUsed = 'true';
        failed.removeAttribute('srcset');
        failed.src = backup;
      }
      root.addEventListener('error', event => useImageBackup(event.target), {...options, capture: true});
      root.querySelectorAll('img[data-mr-image-backup]').forEach(photo => {
        if (photo.complete && !photo.naturalWidth) useImageBackup(photo);
      });
      root.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = event.target.closest('img') || event.target.closest('a')?.querySelector('img');
        if (!target || !root.contains(target) || !target.matches(candidates) || !eligible(target)) return;
        event.preventDefault();
        open(target);
      }, options);
      root.addEventListener('keydown', event => {
        const photo = event.target;
        if (!photo.matches('img[data-mr-enlarge]') || photo.closest('a') || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        open(photo);
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      previous.addEventListener('click', () => show(index - 1), options);
      next.addEventListener('click', () => show(index + 1), options);
      dialog.addEventListener('click', event => {
        if (event.target === dialog || event.target === figure) dialog.close();
      }, options);
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Escape') {
          event.preventDefault();
          dialog.close();
        }
      }, options);
      figure.addEventListener('touchstart', event => {
        touch = event.touches.length === 1 ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
      }, {...options, passive: true});
      figure.addEventListener('touchmove', event => { if (event.touches.length !== 1) touch = null; }, {...options, passive: true});
      figure.addEventListener('touchend', event => {
        if (!touch || event.touches.length) { touch = null; return; }
        const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
        touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      }, {...options, passive: true});
      figure.addEventListener('touchcancel', () => { touch = null; }, options);
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        image.removeAttribute('src');
        image.removeAttribute('data-mr-image-backup');
        restoreFocus?.focus({preventScroll: true});
      }, options);
      const observer = new MutationObserver(records => {
        if (!refreshFrame && records.some(record => !dialog.contains(record.target))) refreshFrame = requestAnimationFrame(refresh);
      });
      observer.observe(root, {childList: true, subtree: true});
      root.dataset.photoViewerReady = 'true';
      refresh();
      controllers.set(root, {destroy() {
        if (dialog.open) { document.body.style.overflow = previousOverflow; dialog.close(); }
        observer.disconnect(); cancelAnimationFrame(refreshFrame);
        events.abort(); delete root.dataset.photoViewerReady; controllers.delete(root);
      }});
    });
  }
  window.MRArticlePhotoViewer = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('#mr-journal').forEach(root => controllers.get(root)?.destroy());
  });
})();
